import React from "react";
import { getCategoryIcon } from "../lib/categories";

export default function CategoryBadge({ category, className = "" }) {
  const Icon = getCategoryIcon(category);
  return (
    <span className={`inline-flex items-center gap-1 font-mono text-[10px] px-2 py-0.5 border font-semibold tracking-[0.1em] bg-[#0025D8]/5 text-[#0025D8] border-[#0025D8]/20 ${className}`}>
      <Icon className="w-2.5 h-2.5 flex-shrink-0" />
      {category}
    </span>
  );
}
